import{z as e}from"zod";const t=e.object({code:e.string().optional()}).strict();export{t as getOrgsQueryDto};
//# sourceMappingURL=get-orgs-query.dto.mjs.map